import React from 'react';
import Switch from '../ui/Switch';

// BL-177 Step 2m: a labeled on/off line (the 3D switch with its words), used for every AI feature option.
export default function LabeledToggle({ label, hint, checked, onChange, disabled = false, busy = false, inline = false }) {
    const id = `toggle-${String(label).toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
    return (
        <div className={inline ? 'inline-flex items-center gap-2' : 'flex flex-wrap items-center justify-between gap-3'}>
            <label htmlFor={id} className="min-w-[10rem] flex-1">
                <span className="block text-sm font-bold text-white">{label}</span>
                {hint && <span className="block text-xs text-[#C7D2E8]">{hint}</span>}
            </label>
            <Switch id={id} label={label} checked={checked === true} onChange={onChange} disabled={disabled} busy={busy} />
        </div>
    );
}
